export const SET_IS_SIDEBAR_COLLAPSED = "SET_IS_SIDEBAR_COLLAPSED";

export const REQUEST_APPLICATION_CONFIGS = "REQUEST_APPLICATION_CONFIGS";
export const RECEIVE_APPLICATION_CONFIGS_SUCCESS =
  "RECEIVE_APPLICATION_CONFIGS_SUCCESS";
export const RECEIVE_APPLICATION_CONFIGS_ERROR =
  "REQUEST_APPLICATION_CONFIGS_ERROR";
